import { gql } from '@apollo/client';

import { LeadFragment } from '../fragments/LeadFragment';

export type {
  GetLead as IGetLead,
  GetLead_lead as IGetLeadLead,
  GetLeadVariables as IGetLeadVariables,
} from './__generated__/GetLead';

export const GET_LEAD = gql`
  query GetLead($sellerInputId: String!) {
    lead(sellerInputId: $sellerInputId) {
      ...LeadFragment
    }
  }
  ${LeadFragment}
`;
